<template>
  <div>
    <ul>
      <li v-for='hazard in hazards'>
        <div><p><span class="game-hazard">Hazard</span> <b><span v-html="colorize(hazard.name)"></span>:</b> <span v-html="colorize(hazard.description)"></span></p></div>
        <div><p v-if='hazard.challenge_level'><b>Challenge:</b> {{ hazard.challenge_level }}</p></div>

        <outcomes :outcomes="outcomesFor(hazard)" hideChainable :showOnly='["cost", "effect"]'></outcomes>
      </li>
    </ul>
  </div>
</template>

<script>
import Outcomes from '../shared/outcomes.vue';
import ListContainer from '../shared/list-container.vue';
import colorizeKeywords from './colorize.js';

import { sortBy } from 'lodash';

export default {
  name: 'hazards',

  components: { ListContainer, Outcomes },

  props: {
    hazards: {
      type: Array,
      default: () => []
    }
  },

  mounted: function() {
    console.log(this.hazards);
  },

  methods: {
    outcomesFor(item) {
      return sortBy(item.outcomes, 'cost');
    },

    colorize(text) { return colorizeKeywords(text); }
  }
}
</script>
